module.exports = __webpack_public_path__ + "media/images/pages/secondary-senior-leaders/secondary_brochure-06fe7b2c026b3d054ca407c08f7488d1.svg";